import { mvmHudBlobUrl } from '../pages/hex-battle/constants'

/** Elemental / extra icons — not all ship in `mvm/new`; keep legacy blob paths. */
const MVM_ACTION_BLOB_LEGACY = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/mvm'

/** Hex / MvM enemy action panel frame (layered over bg). */
export const MVM_ACTION_PANEL_BG = mvmHudBlobUrl('action-panel-bg.webp')
export const MVM_ACTION_PANEL_TOP = mvmHudBlobUrl('action-panel-top.webp')
export const MVM_ACTION_PANEL_BOTTOM = mvmHudBlobUrl('action-panel-bottom.webp')

export const MVM_ACTION_IMAGE_URLS: Record<string, string> = {
  BASE: mvmHudBlobUrl('base.webp'),
  ULTIMATE: mvmHudBlobUrl('ultimate.webp'),
  REST: `${MVM_ACTION_BLOB_LEGACY}/rest.webp`,
  SPECIAL: mvmHudBlobUrl('special.webp'),
  DUEL: mvmHudBlobUrl('duel.webp'),
  GO: mvmHudBlobUrl('go.webp'),
  wind: `${MVM_ACTION_BLOB_LEGACY}/wind.webp`,
}

const CRAFT_BASIC_THUMB = (file: string) =>
  `https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/craft_items/black-smith-weapons/${file}`

/** Blacksmith basic items — same card art as main game / blacksmith page (HUD chips). */
export const MVM_BASIC_WEAPON_IMAGE_URLS: Record<string, string> = {
  phase_boot: CRAFT_BASIC_THUMB('phase-boot.webp'),
  shield: CRAFT_BASIC_THUMB('shield.webp'),
  claymore: CRAFT_BASIC_THUMB('claymore.webp'),
  lifesteal_sword: CRAFT_BASIC_THUMB('lifesteal-sword.webp'),
  blade_mail: CRAFT_BASIC_THUMB('blade-mail.webp'),
  soul_trompeta: CRAFT_BASIC_THUMB('soul-trompeta.webp'),
  helm_of_verdant_dragon: CRAFT_BASIC_THUMB('helm-verdant.webp'),
  hydrafang_dagger: CRAFT_BASIC_THUMB('hydrafang-dagger.webp'),
  eagle_eye_bowstring: CRAFT_BASIC_THUMB('eagle-eye-bowstring.webp'),
  piercing_spear: CRAFT_BASIC_THUMB('piercing-pear.webp'),
  dragon_linebreaker: CRAFT_BASIC_THUMB('dragon-linebreaker.webp'),
  infernal_bomb_blade: CRAFT_BASIC_THUMB('infernal-bomb-blade.webp'),
  shadowstep_boots: CRAFT_BASIC_THUMB('shadowstep-boots.webp'),
  guardian_chestplate: CRAFT_BASIC_THUMB('guardian-chestplate.webp'),
  warrior_heart_pendant: CRAFT_BASIC_THUMB('warrior-heart-pendant.webp'),
}

export const MVM_EPIC_WEAPON_IMAGE_URLS: Record<string, string> = {
  bloodpetal_cataclysm:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Bloodpetal%20Cataclysm.webp',
  mantle_of_absolute_evasion:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Mantle%20of%20Absolute%20Evasion.webp',
  cataclysm_breaker_carapace:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Cataclysm%20Breaker%20Carapace.webp',
  horn_of_the_skyforged_charge:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Horn%20of%20the%20Skyforged%20Charge.webp',
  idol_of_withered_might:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Idol%20of%20Withered%20Might.webp',
  sunheart_aegis:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Sunheart%20Aegis.webp',
  damnation_paradox_mirror:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Damnation%20Paradox%20Mirror.webp',
  recipe_of_endless_repose:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Recipe%20of%20Endless%20Repose.webp',
  vital_surge:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Vital%20Surge.webp',
  eclipse_backlash:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Eclipse%20Backlash.webp',
  fateweaver_sigil:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Fateweaver%20Sigil.webp',
  voidflux_annihilator:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Voidflux%20Annihilator.webp',
  grim_leech_scythe:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Grim%20Leech%20Scythe.webp',
  bulwark_of_the_faithful:
    'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/craft_weapons/epic/Bulwark%20of%20the%20Faithful.webp',
}

/** Character info panel — vertical three-slice frame + per-stat row border (same blob tree as HUD). */
const MVM_BATTLE_PANEL_BLOB = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/mvm/battle'
export const MVM_CHARACTER_PANEL_TOP_URL = `${MVM_BATTLE_PANEL_BLOB}/character-panel-top.webp`
export const MVM_CHARACTER_PANEL_MID_URL = `${MVM_BATTLE_PANEL_BLOB}/character-panel-center.webp`
export const MVM_CHARACTER_PANEL_BOTTOM_URL = `${MVM_BATTLE_PANEL_BLOB}/character-panel-bottom.webp`
/** Horizontal inset for panel content inside the frame art. */
export const MVM_CHARACTER_PANEL_PADDING_X_PX = 20
/** Vertical inset for panel content (in addition to inner blocks). */
export const MVM_CHARACTER_PANEL_PADDING_Y_PX = 28
/** Pull top/bottom cap `<img>` past the panel edge (px); overflow remains visible via positioned layers. */
export const MVM_CHARACTER_PANEL_CAP_OUTSET_PX = 10
export const MVM_PANEL_ITEM_BORDER_URL = `${MVM_BATTLE_PANEL_BLOB}/panel-item-border.webp`
/** Turn-order strip — wallet profile photo ring (`mvm/battle`). */
export const MVM_TURN_ORDER_AVATAR_FRAME_URL = `${MVM_BATTLE_PANEL_BLOB}/character-avatar-frame.webp`
/** Siege bread counter chip — ornate panel; bread art on left, label + count on right (`mvm/battle`). */
export const MVM_BREAD_PANEL_BG_URL = `${MVM_BATTLE_PANEL_BLOB}/bread-panel-bg.webp`

/** Full-width HUD bottom frame: corner (×2 mirrored) + mid connectors + repeating center (`mvm/battle`). */
export const MVM_BATTLE_BOTTOM_CORNER_URL = `${MVM_BATTLE_PANEL_BLOB}/bottom-corner.webp`
export const MVM_BATTLE_BOTTOM_LEFT_MID_CONNECTOR_URL = `${MVM_BATTLE_PANEL_BLOB}/bottom-left-mid-connector.webp`
export const MVM_BATTLE_BOTTOM_MID_URL = `${MVM_BATTLE_PANEL_BLOB}/bottom-mid.webp`
export const MVM_BATTLE_BOTTOM_RIGHT_MID_CONNECTOR_URL = `${MVM_BATTLE_PANEL_BLOB}/bottom-right-mid-connector.webp`
/** Fallback mid-strip height before connector images report `naturalHeight` (should match real connector art). */
export const MVM_BATTLE_BOTTOM_CONNECTOR_HEIGHT_FALLBACK_PX = 32

/** Precache URLs: HUD blob art + action icons, legacy-blob rows, basic + epic craft thumbnails. */
export function getAllMvmUiBlobPrecacheUrls(): string[] {
  const local = [
    MVM_ACTION_PANEL_BG,
    MVM_ACTION_PANEL_TOP,
    MVM_ACTION_PANEL_BOTTOM,
    MVM_CHARACTER_PANEL_TOP_URL,
    MVM_CHARACTER_PANEL_MID_URL,
    MVM_CHARACTER_PANEL_BOTTOM_URL,
    MVM_PANEL_ITEM_BORDER_URL,
    MVM_TURN_ORDER_AVATAR_FRAME_URL,
    MVM_BREAD_PANEL_BG_URL,
    MVM_BATTLE_BOTTOM_CORNER_URL,
    MVM_BATTLE_BOTTOM_LEFT_MID_CONNECTOR_URL,
    MVM_BATTLE_BOTTOM_MID_URL,
    MVM_BATTLE_BOTTOM_RIGHT_MID_CONNECTOR_URL,
    MVM_ACTION_IMAGE_URLS.BASE,
    MVM_ACTION_IMAGE_URLS.ULTIMATE,
    MVM_ACTION_IMAGE_URLS.SPECIAL,
    MVM_ACTION_IMAGE_URLS.DUEL,
    MVM_ACTION_IMAGE_URLS.GO,
  ]
  return [
    ...new Set([
      ...local,
      ...Object.values(MVM_ACTION_IMAGE_URLS),
      ...Object.values(MVM_BASIC_WEAPON_IMAGE_URLS),
      ...Object.values(MVM_EPIC_WEAPON_IMAGE_URLS),
    ]),
  ]
}
